import { Spin } from "antd";
import useDriverDetail from "hooks/drivers/useDriverDetail";
import DriverInfo from "./components/DriverInfo";
import BasicInfo from "./components/BasicInfo";
import FleetInfo from "./components/FleetInfo";
import Images from "./components/Images";

export default function DriverDetail() {
  const {
    data: { loading, data },
    handleCloseDelete,
    handleOpenDelete,
    handleOpenActivate,
    handleOpenBan,
    fetchData,
    handleCloseActivate,
    handleCloseBan,
    openActivate,
    openBan,
    openDelete,
    handleCloseVerify,
    handleOpenVerify,
    openVerify,
  } = useDriverDetail();

  return (
    <div className="w-full">
      {loading ? (
        <div
          className="w-full bg-white rounded-lg p-6"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <div className="w-full flex items-center justify-center py-20">
            <Spin />
          </div>
        </div>
      ) : (
        <div className="w-full flex flex-col gap-y-10">
          <DriverInfo
            handleCloseDelete={handleCloseDelete}
            openDelete={openDelete}
            handleOpenDelete={handleOpenDelete}
            handleOpenActivate={handleOpenActivate}
            handleOpenBan={handleOpenBan}
            data={data}
            handleCloseActivate={handleCloseActivate}
            handleCloseBan={handleCloseBan}
            openActivate={openActivate}
            openBan={openBan}
            handleCloseVerify={handleCloseVerify}
            openVerify={openVerify}
            handleOpenVerify={handleOpenVerify}
            reload={fetchData}
          />
          <div className="w-full flex gap-x-8">
            <BasicInfo data={data} />
            <FleetInfo data={data} />
          </div>
          <Images data={data} />
        </div>
      )}
    </div>
  );
}
